/**
 * Module definition houses global endpoints services
 *
 * @module services.endpoints
 */
angular.module('services.endpoints', [
  'services.endpoints.EndpointsService',
  'services.endpoints.MethodsService',
  'services.endpoints.RelativesService'
]);
